export const AUDIT_ACTIONS = [
  { value: 'create', label: 'Creación' },
  { value: 'update', label: 'Actualización' },
  { value: 'delete', label: 'Eliminación' },
  { value: 'login', label: 'Inicio de sesión' },
];

export const AUDIT_MODULES = {
  auth: 'Autenticación',
  carrusel: 'Carrusel',
  home_popup: 'Avisos emergentes (inicio)',
  noticias: 'Noticias',
  vacaciones: 'Sedes vacacionales',
  creditos: 'Créditos',
  normatividad: 'Normatividad',
  normatividad_categorias: 'Categorías normatividad',
  convenios: 'Convenios',
  emprendimientos: 'Emprendimientos',
  contacto: 'Contacto / PQRS',
  entes_administrativos: 'Entes administrativos',
};

export function getAuditActionLabel(value) {
  return AUDIT_ACTIONS.find((a) => a.value === value)?.label ?? value;
}

export function getAuditModuleLabel(value) {
  return AUDIT_MODULES[value] ?? value;
}
